import { Controller } from "@hotwired/stimulus"

// Adiciona e remove linhas de um form aninhado (fields_for) a partir de um
// <template>. O placeholder do child_index precisa virar um NÚMERO: strong
// params só reconhece nested attributes cuja chave case /\A-?\d+\z/, e uma
// chave como "new_line_items" faria os params serem descartados em silêncio.
export default class extends Controller {
  static targets = ["template", "anchor", "item"]
  static values = { placeholder: { type: String, default: "NEW_RECORD" } }

  add(event) {
    event.preventDefault()

    const html = this.templateTarget.innerHTML.replaceAll(
      this.placeholderValue,
      Date.now().toString()
    )

    this.anchorTarget.insertAdjacentHTML("beforebegin", html)
  }

  // Registro persistido é marcado com _destroy e escondido; o que ainda não
  // existe no banco pode simplesmente sair do DOM.
  remove(event) {
    event.preventDefault()

    const item = event.target.closest("[data-nested-form-target='item']")
    if (!item) return

    const destroyField = item.querySelector("input[name*='_destroy']")

    if (destroyField) {
      destroyField.value = "1"
      item.classList.add("hidden")
    } else {
      item.remove()
    }
  }
}
